export const reward = [
  {
    name: 'Index',
    url: '/reward/',
    icon: 'icon-home'
  },
  {
    name: 'Create Reward',
    url: '/reward/create',
    icon: 'icon-plus'
  }
];
